import { exitImpersonation, getImpersonationState } from '@/lib/impersonation';
import { Button } from '@/components/ui/Button';
import { ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function ImpersonationBanner() {
  const state = getImpersonationState();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!state) return null;

  async function handleExit() {
    setBusy(true);
    try {
      await exitImpersonation();
      navigate('/admin/users');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="border-b border-amber-500/30 bg-amber-500/10 px-3 py-2 sm:px-6">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2 text-sm text-amber-100">
          <ShieldAlert className="mt-0.5 size-4 shrink-0" />
          <p>
            Support mode — viewing as <strong>{state.target_email}</strong>.
            Actions are performed as this user and should be used for troubleshooting only.
          </p>
        </div>
        <Button variant="secondary" size="sm" onClick={handleExit} disabled={busy} className="shrink-0">
          Exit support mode
        </Button>
      </div>
    </div>
  );
}
